import styled from '@emotion/styled';
import { Button } from '@kizen/kds/Button';
import { Typography } from '@kizen/kds/Typography';
import { ErrorMessage } from '__components/ErrorMessage';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ButtonWrapper = styled.div`
  padding-top: 40px;
`;

export const PlanPage = () => {
  const { t } = useTranslation();
  const business = useSelector((s: any) => s.authentication.chosenBusiness);

  return (
    <div>
      <ErrorMessage
        title={t('Contact Sales to Upgrade')}
        text={
          <Typography>
            {t(
              "You've reached a limit of your plan for the current billing cycle. Please contact sales to upgrade your business."
            )}
          </Typography>
        }
        button={
          <ButtonWrapper>
            <a
              href={`mailto:sales@kizen.com?subject=Upgrade Request for "${business?.name ?? 'Business'}"`}
            >
              <Button>{t('Contact Sales')}</Button>
            </a>
          </ButtonWrapper>
        }
        code={undefined}
        supportEmail={undefined}
      />
    </div>
  );
};
